import { render, staticRenderFns } from "./venueDetails.vue?vue&type=template&id=09c46c32&"
import script from "./venueDetails.vue?vue&type=script&lang=js&"
export * from "./venueDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports